import React from 'react';
import { Card, CardContent } from '@frontend/shadcn/components/ui/card';
import { Skeleton } from '@frontend/shadcn/components/ui/skeleton';
import {
  AtIcon,
  MapPinIcon,
  UserGroupIcon,
} from '@revfluence/fresh-icons/solid/esm';
import { getCountryLabel } from '../../../components/filters-form/utils';
import type { CreatorProfileCardProps } from './hooks'; // CORRECT IMPORT

export const CreatorProfileCard: React.FC<CreatorProfileCardProps> = ({
  username,
  email,
  country,
  totalFollowers,
  isLoading, // Prop from imported interface
}) => {
  if (isLoading) {
    return (
      <Card className="m-4 bg-[#F9FAFB] border-none">
        <CardContent className="p-4 space-y-1 mt-4">
          <Skeleton className="h-6 w-3/4 mb-1" />
          <div className="flex items-center">
            <Skeleton className="h-4 w-4 mr-1 rounded-sm" />
            <Skeleton className="h-4 w-4/5" />
          </div>
          <div className="flex items-center">
            <Skeleton className="h-4 w-4 mr-1 rounded-sm" />
            <Skeleton className="h-4 w-3/5" />
          </div>
          <div className="flex items-center">
            <Skeleton className="h-4 w-4 mr-1 rounded-sm" />
            <Skeleton className="h-4 w-2/5" />
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="m-4 bg-[#F9FAFB] border-none">
      <CardContent className="p-4 space-y-1 mt-4">
        <div>
          <p className="font-bold text-md">{username}</p>
        </div>
        <div className="flex items-center text-sm text-muted-foreground">
          <AtIcon className="h-4 w-4 mr-1" style={{ color: '#4F5ABA' }} />
          <span>{email || 'N/A'}</span>
        </div>
        <div className="flex items-center text-sm text-muted-foreground">
          <MapPinIcon className="h-4 w-4 mr-1" style={{ color: '#CB4349' }} />
          <span>
            {country ? getCountryLabel(country) : 'N/A'}
          </span>
        </div>
        <div className="flex items-center text-sm text-muted-foreground">
          <UserGroupIcon className="h-4 w-4 mr-1" style={{ color: '#4F7DBA' }} />
          <span>
            {(totalFollowers !== null && totalFollowers !== undefined) ? totalFollowers.toLocaleString() : 'N/A'}
          </span>
        </div>
      </CardContent>
    </Card>
  );
};

CreatorProfileCard.displayName = 'CreatorProfileCard';
